import { useCallback, useEffect, useState } from 'react'
import { IMAGE_FALLBACK_SRC } from './fallback-image'

export const useImageFallback = (src: string | null | undefined) => {
  const [failedSrc, setFailedSrc] = useState<string>()

  useEffect(() => {
    setFailedSrc(undefined)
  }, [src])

  const onError = useCallback(() => setFailedSrc(src ?? undefined), [src])
  const isFallback = !src || failedSrc === src

  return { imageSrc: !src || failedSrc === src ? IMAGE_FALLBACK_SRC : src, isFallback, onError }
}

// CSS backgrounds need a load observer because they do not emit element image errors.
export const usePreloadedImageFallback = (src: string | null | undefined) => {
  const result = useImageFallback(src)
  const { onError } = result

  useEffect(() => {
    if (!src) return
    let active = true
    const image = new window.Image()
    image.onerror = () => {
      if (active) onError()
    }
    image.src = src
    return () => {
      active = false
      image.onerror = null
    }
  }, [src, onError])

  return result
}
